module.exports = __webpack_public_path__ + "img/p2-pic.4a5d358d.jpg";